import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import GeneralAlert from "../../components/common/GeneralAlert";
import { Work } from "../../types/work";
import useWorkLogic from "../../hooks/logic/workLogic";

interface WorkPageWrapperProps {
  Component: React.FC<{
    systemLanguageType: Work["system_language_type"];
  }>;
}

const WorkPageWrapper: React.FC<WorkPageWrapperProps> = ({ Component }) => {
  const navigate = useNavigate();
  const { system_language_type } = useParams<{
    system_language_type?: string;
  }>();
  const { systemLanguageType } = useWorkLogic(system_language_type);

  if (!systemLanguageType) {
    return (
      <GeneralAlert
        errorMessage="Invalid system language type"
        action={() => navigate(-1)}
        actionLabel="Go Back"
      />
    );
  }

  return <Component systemLanguageType={systemLanguageType} />;
};

export default WorkPageWrapper;
